export const Products = [
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwf97a6473/crop/026414639_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Butterfly",
    subtitle: "Fine Fragrance Mist",
    price: 17.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwe52c7f04/crop/026403504_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Sandawood Eucalyptus Mandarin",
    subtitle: "Body Wash and Foam Bath",
    price: 15.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwff743235/crop/026438530_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New",
    title: "Japanese Cherry Blossom",
    subtitle: "Ultimate Hydration Body Cream",
    price: 15.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwba77ffbc/crop/026267868_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New",
    title: "Ocean",
    subtitle: "Body Spray",
    price: 13.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw81522767/crop/026401914_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Pineapple Lime Eucalyptus",
    subtitle: "Essential Oil Mist",
    price: 15.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dweccfb026/crop/026451873_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New",
    title: "Buttercups & Berry Bellini",
    subtitle: "Fine Fragrance Mist",
    price: 15.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw65573859/crop/026451884_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Hibiscus Mandarin Violet",
    subtitle: "Ultimate Hydration Body Cream",
    price: 17.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Frese",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw50a09db0/crop/026395407_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New!",
    title: "Freshwater",
    subtitle: "3-in-1-Hair, Face & Body Wash",
    price: 14.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwd097b2cd/crop/026451889_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Honeysuckle & Peach Spritz",
    subtitle: "Ultimate Body Hydration Cream",
    price: 15.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwc02b92b6/crop/026381189_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Cacao Rose",
    subtitle: "Body Wash & Foam Bath",
    price: 15.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw7c6a3bb3/crop/026400330_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Strawberry Pound Cake",
    subtitle: "Fine Fragrance Mist",
    price: 17.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwaf5dec98/crop/026439080_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Lavender Mint Tea",
    subtitle: "Ultimate Hydration Buy Cream",
    price: 17.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwc189b575/crop/026240389_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New",
    title: "A Thousand Wishes",
    subtitle: "Super Smooth Body Lotion",
    price: 13.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw8a157107/crop/026353232_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Lavender and Vanilla",
    subtitle: "Pillow and Body Mist",
    price: 14.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwae11afdf/crop/026438528_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New!",
    title: "Japanese Cherry Blossom",
    subtitle: "Fine Fragrance Mist",
    price: 16.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwddbaf67c/crop/026311427_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "",
    title: "Noir",
    subtitle: "Ultimate Hydration Body Cream",
    price: 15.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwaa9a590e/crop/026400298_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Pineapple Lime Eucalyptus",
    subtitle: "Body Wash and Foam",
    price: 15.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw77031493/crop/026400299_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Hibiscus Mandarin Violet",
    subtitle: "Body Wash and Foam",
    price: 15.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw78b6f36e/crop/026414641_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Butterfly",
    subtitle: "Ultimate Hydration Body Cream",
    price: 16.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwb37ec169/crop/026403500_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Sandalwood Eucalyptus Mandarin",
    subtitle: "Ultimate Hydration Body Cream",
    price: 17.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw405fd62d/crop/026401906_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Pineapple Lime Eucalyptus",
    subtitle: "Ultimate Hydration Body Cream",
    price: 17.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw65573859/crop/026451884_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Honeysuckle & Peach Spritz",
    subtitle: "Fine Fragrance Mist",
    price: 15.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw3e419c30/crop/026438526_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New!",
    title: "Japanese Cherry Blossom",
    subtitle: "Daily Nourishing Body Lotion",
    price: 14.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw7a9cd531/crop/026438524_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New!",
    title: "Japanese Cherry Blossom",
    subtitle: "Shower Gel",
    price: 13.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw744d9e74/crop/026414637_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Butterfly",
    subtitle: "Daily Nourishing Body Lotion",
    price: 15.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwe8bc2c4c/crop/026401902_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Pineapple Lime Eucalyptus",
    subtitle: "Moisturizing Body Lotion",
    price: 16.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw03a2e5ae/crop/026451890_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Buttercups & Berry Bellini",
    subtitle: "Ultimate Hydration Body Lotion",
    price: 15.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwa79df475/crop/026401903_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Hibiscus Mandarin Violet",
    subtitle: "Moisturising Body Lotion",
    price: 16.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw0b5bbf2c/crop/026398798_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Sandalwood Eucalyptus Mandarin",
    subtitle: "Moisturizing Body Lotion",
    price: 16.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw2928b4c4/crop/026451871_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Honesuckle & Peach Spritz",
    subtitle: "Shower Gel",
    price: 13.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw06129964/crop/026451891_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New!",
    title: "White Tea & Sage",
    subtitle: "Ultimate Hydration Body Cream",
    price: 15.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw4b4aaf7f/crop/026451872_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Buttercups & Berry Bellini",
    subtitle: "Shower Gel",
    price: 13.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwb9adb1da/crop/026403506_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Sandalwood Eucalyptus Mandarin",
    subtitle: "Essential Oil Mist",
    price: 15.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw234a33a8/crop/026401915_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Hibiscus Mandarin Violet",
    subtitle: "Essential Oil Mist",
    price: 15.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw489f00f7/crop/026395413_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New!",
    title: "Freshwater",
    subtitle: "Ultimate Hydration Body Cream",
    price: 15.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw170d959f/crop/026413789_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "",
    title: "Mongilia Charm",
    subtitle: "Ultimate Hydration Body Cream",
    price: 15.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw8b383976/crop/026413955_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Butterfly",
    subtitle: "Bubble Bath",
    price: 17.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw7e5f24d0/crop/026403502_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Sandalwood Eucalyptus Mandarin",
    subtitle: "Shower Steamers",
    price: 18.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw5ed672f7/crop/026439892_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Summer Melody",
    subtitle: "Hand Cream",
    price: 7.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw26f54fa4/crop/026401910_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "New Fragrance",
    subtitle: "Pineapple Lime Eucalyptus",
    price: 18.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw5690febd/crop/026401911_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Hibiscus Mandarin Violet",
    subtitle: "Shower Steamers",
    price: 18.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwe5099953/crop/026414635_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New Fragrance",
    title: "Butterfly",
    subtitle: "Shower Gel",
    price: 14.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw559bb7e6/crop/026438532_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New!",
    title: "Japanese Cherry Blossom",
    subtitle: "Moisturizing Body Wash",
    price: 13.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    image:
      "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw3fc3591d/crop/026438534_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    fragrance_type: "New!",
    title: "Japanese Cherry Blossom",
    subtitle: "Diamond Shimmer Mist",
    price: 15.5,
    offers: "Mix & Match: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
];
